import type { PaymentSummaryData } from '../../types/report';

interface PaymentPieChartProps {
  data: PaymentSummaryData[];
}

const COLORS = ['#3b82f6', '#10b981', '#f59e0b'];

const formatCurrency = (value: number) => {
  if (value >= 100000000) {
    return `${(value / 100000000).toFixed(2)}억`;
  }
  if (value >= 10000) {
    return `${(value / 10000).toFixed(0)}만`;
  }
  return value.toLocaleString();
};

export const PaymentPieChart = ({ data }: PaymentPieChartProps) => {
  return (
    <div className="flex flex-col lg:flex-row gap-6">
      <div className="flex-1">
        <h4 className="mb-4 text-sm font-medium text-gray-700">실현 매출 구성 비중</h4>
        <div className="space-y-4">
          {data.map((item, index) => (
            <div key={item.category}>
              <div className="flex justify-between items-center mb-1.5">
                <div className="flex items-center gap-2">
                  <div className="w-3 h-3 rounded-sm" style={{ backgroundColor: COLORS[index] }} />
                  <span className="text-sm text-gray-700">{item.category}</span>
                </div>
                <span className="text-sm font-semibold" style={{ color: COLORS[index] }}>
                  {item.proportion}%
                </span>
              </div>
              <div className="h-7 bg-gray-100 rounded-md overflow-hidden">
                <div
                  className="h-full rounded-md flex items-center justify-end pr-2 transition-all duration-500"
                  style={{
                    width: `${Math.max(item.proportion, 1.5)}%`,
                    backgroundColor: COLORS[index],
                  }}
                >
                  {item.proportion >= 10 && (
                    <span className="text-xs text-white font-medium">{item.proportion}%</span>
                  )}
                </div>
              </div>
              <p className="mt-1 text-xs text-gray-400 text-right">
                {formatCurrency(item.actualRevenue)}원
              </p>
            </div>
          ))}
        </div>
      </div>

      <div className="flex-1">
        <h4 className="mb-4 text-sm font-medium text-gray-700">결제 현황 상세</h4>
        <div className="space-y-4">
          {data.map((item, index) => (
            <div key={item.category} className="rounded-lg border p-3">
              <div className="flex items-center gap-2 mb-2">
                <div
                  className="w-3 h-3 rounded-full"
                  style={{ backgroundColor: COLORS[index] }}
                />
                <span className="font-medium">{item.category}</span>
                <span className="ml-auto text-sm font-semibold" style={{ color: COLORS[index] }}>
                  {item.proportion}%
                </span>
              </div>
              <div className="grid grid-cols-2 gap-2 text-sm">
                <div>
                  <span className="text-gray-500">기대 매출:</span>
                  <span className="ml-2 font-medium">{formatCurrency(item.expectedRevenue)}</span>
                </div>
                <div>
                  <span className="text-gray-500">실현 매출:</span>
                  <span className="ml-2 font-medium">{formatCurrency(item.actualRevenue)}</span>
                </div>
                <div>
                  <span className="text-gray-500">수금률:</span>
                  <span className="ml-2 font-medium text-green-600">{item.collectionRate}%</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
